import { createSelector } from '@reduxjs/toolkit';
const getCustomer = (state) => state.customer.data;
const getLoading = (state) => state.customer.loading;
const getError = (state) => state.customer.error;
const makeCustomer = createSelector([getCustomer], (customer) => {
    return {
        _id: customer._id || '',
        name: customer.name || '',
        email: customer.email || '',
        company: customer.company || '',
        companyDescription: customer.companyDescription || '',
    };
});
export const CustomerSelectors = {
    getLoading,
    getError,
    makeCustomer,
};
